"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareClaimTokenInitialValues = exports.claimTokenFilter = exports.claimTokenSearchValuesCreator = exports.claimTokenEmptyValuesCreator = void 0;
const types_1 = require("@framework/types");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const exchange_1 = require("@framework/exchange");
const types_2 = require("../../../../../types");
const baseEmptyValues = {
    account: "",
    item: mui_inputs_asset_1.emptyToken,
    endTimestamp: new Date(0).toISOString(),
};
const claimTokenEmptyValuesCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        ...baseEmptyValues,
    },
    [types_2.ServiceType.OFFICE]: {
        ...baseEmptyValues,
        merchantId: profile.merchantId,
    },
});
exports.claimTokenEmptyValuesCreator = claimTokenEmptyValuesCreator;
const claimTokenSearchValuesCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        claimStatus: [types_1.ClaimStatus.NEW],
    },
    [types_2.ServiceType.OFFICE]: {
        claimStatus: [types_1.ClaimStatus.NEW],
        merchantId: profile.merchantId,
    },
});
exports.claimTokenSearchValuesCreator = claimTokenSearchValuesCreator;
const claimTokenFilter = ({ item, account, endTimestamp }) => ({
    item: (0, exchange_1.cleanUpAsset)(item),
    account,
    endTimestamp,
});
exports.claimTokenFilter = claimTokenFilter;
const prepareClaimTokenInitialValues = ({ id, item, account, endTimestamp }) => {
    return {
        id,
        item,
        account,
        endTimestamp,
    };
};
exports.prepareClaimTokenInitialValues = prepareClaimTokenInitialValues;
//# sourceMappingURL=schemas.js.map